import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ToastService } from '../../services/toast.service';
import { IconComponent } from '../icon/icon.component';

@Component({
  selector: 'wg-toasts',
  standalone: true,
  imports: [CommonModule, IconComponent],
  template: `
    <div class="toast-stack">
      @for (t of toastService.toasts(); track t.id) {
        <div class="toast fade-up" [class.error]="t.kind === 'error'" (click)="toastService.dismiss(t.id)">
          <wg-icon [name]="iconFor(t.kind)" [size]="15" />
          <span class="toast-body">
            {{ t.message }}
            @if (t.detail) {
              <span class="toast-detail">{{ t.detail }}</span>
            }
          </span>
        </div>
      }
    </div>
  `,
  styles: [`
    .toast-stack {
      position: fixed;
      bottom: 24px;
      left: 50%;
      transform: translateX(-50%);
      z-index: 200;
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 8px;
    }
    .toast {
      background: var(--text);
      color: var(--bg);
      border-radius: 10px;
      padding: 10px 16px;
      font-size: 13px;
      font-weight: 550;
      box-shadow: var(--shadow-3);
      display: flex;
      align-items: center;
      gap: 8px;
      max-width: 480px;
      cursor: pointer;
    }
    .toast.error { background: var(--red); color: #fff; }
    .toast-body { display: flex; flex-direction: column; min-width: 0; }
    .toast-detail { font-weight: 400; font-size: 12px; opacity: 0.8; }
  `],
})
export class ToastComponent {
  readonly toastService = inject(ToastService);

  iconFor(kind: 'success' | 'error' | 'info'): string {
    return kind === 'error' ? 'alert' : kind === 'info' ? 'chat' : 'check-circle';
  }
}
